import { Component } from '@angular/core'
import { Router, RouterOutlet } from '@angular/router'
import { AppComponent } from 'app/app.component'
import { CurrentUserService } from 'app/shared/services/current-user.service'
import { MessageBusService } from 'app/shared/services/message-bus.service'
import { ConfirmationService } from 'primeng/api'
import { Button } from 'primeng/button';

@Component({
    selector: 'app-basic-layout',
    templateUrl: './basic-layout.component.html',
    styleUrls: ['./basic-layout.component.scss'],
    standalone: true,
    imports: [Button, RouterOutlet],
})
export class BasicLayoutComponent {
  constructor(
    public app: AppComponent,
    public router: Router,
    public messageBusService: MessageBusService,
    private currentUserService: CurrentUserService,
    private confirmationService: ConfirmationService
  ) {}

  ngOnInit(): void {}

  onLogoutClick() {
    this.confirmationService.confirm({
      message: 'Are you sure you want to logout?',
      header: 'Confirm',
      icon: 'fa-solid fa-arrow-right-from-bracket',
      accept: () => this.currentUserService.signOut(),
    })
  }
}
